import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
    this.payMethodValidation = function () {
        const dictonary = {
            custom: {
                code: {
                    required: () => t.t(dictEnum.LBL_PayMethod) + t.t(dictEnum.WARN_IsRequired)
                },
                bank: {
                    required: () => t.t(dictEnum.LBL_Bank) + t.t(dictEnum.WARN_IsRequired)
                },
                AC: {
                    required: () => t.t(dictEnum.LBL_AC) + t.t(dictEnum.WARN_IsRequired)
                },
                bankFileType: {
                    required: () => t.t(dictEnum.LBL_BankFileType) + t.t(dictEnum.WARN_IsRequired)
                },
            }
        };
        Validator.localize('en', dictonary);
    }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S082200-PayMethod/S082200-PayMethodValidation.js